<rid-lingo-marquee [mood]="marqueeMood()">
  <div class="flex flex-col gap-4 rounded-3xl bg-linear-to-b from-[#1f8c95] to-[#17737c] p-6 shadow-[inset_0_4px_16px_rgb(0_0_0/0.35)]">
    @for (row of rows; track $index; let first = $first) {
      <div class="flex justify-center gap-6">
        @for (group of row; track $index) {
          <div class="flex gap-2 rounded-2xl bg-white/28 p-2">
            @for (klank of group; track klank) {
              <button type="button" [class]="klankKeyClass(klank)" [disabled]="disabled()" (click)="type(klank)">
                {{ klank }}
              </button>
            }
          </div>
        }

        @if (first) {
          <div class="flex gap-2 rounded-2xl bg-white/28 p-2">
            <button type="button" aria-label="Wissen" [class]="eraseKeyClass()" [disabled]="!canErase()" (click)="erased.emit()">
              <svg
                class="size-10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 5h11a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9l-6-7z" />
                <path d="m17 9-5 6m0-6 5 6" />
              </svg>
            </button>
            <button type="button" aria-label="Controleren" [class]="submitKeyClass()" [disabled]="!canSubmit()" (click)="submitted.emit()">
              <svg
                class="size-10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M19 5v7a3 3 0 0 1-3 3H6" />
                <path d="m10 11-4 4 4 4" />
              </svg>
            </button>
          </div>
        }
      </div>
    }
  </div>
</rid-lingo-marquee>
